// import Vue from 'vue'
import Vue from 'vue'
import {
  GET_PROJECT_STATUS,
  ERROR_XHR
} from '../mutation-types'

/**
 *
 * @param dispatch
 * @returns {Promise}
 */
export const getProjectStatus = ({ dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http
      .get('project_status')
      .then(
        (response) => {
          dispatch(GET_PROJECT_STATUS, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/projectStatusActions.js